export default "/static/dashboard/build/app/img/v2/4be65fde10ac29cdda84950a45191aff.png";